export interface BillingPackage {
  id: string;
  name: string;
  tagline: string;
  monthlyPrice: number | null;
  yearlyPrice: number | null;
  annualMonthlyPrice?: number;
  priceLabel?: string;
  features: string[];
  popular?: boolean;
  /** Enterprise / custom — talk to sales only. */
  custom?: boolean;
  mailSubject: string;
}

/** One LinkedIn account and the contacts it can actually touch. Annual is $109 every month, not a yearly lump. yearlyPrice is 109×12 and is not what Stripe charges. */
export const LINKEDIN_ONLY: BillingPackage = {
  id: 'extension',
  name: 'LinkedIn only',
  tagline: 'One LinkedIn account, with the people it can reach',
  monthlyPrice: 129,
  annualMonthlyPrice: 109,
  yearlyPrice: 1308,
  features: [
    '1 LinkedIn account',
    '400 enriched contacts with signals / month',
    'No email and no calling',
  ],
  mailSubject: 'Halr LinkedIn only',
};

/** Self-serve Odin plans. Calling is Enterprise only. */
export const BILLING_PACKAGES: BillingPackage[] = [
  {
    id: 'starter',
    name: 'Starter',
    tagline: 'LinkedIn and email for a small team',
    monthlyPrice: 349,
    annualMonthlyPrice: 299,
    yearlyPrice: 3588,
    features: [
      'LinkedIn and email',
      '5 LinkedIn accounts',
      '5 managed mailboxes (~250 emails/day)',
      '2,500 new contacts / month',
      'Research and copy included',
    ],
    mailSubject: 'Halr Starter plan',
  },
  {
    id: 'growth',
    name: 'Growth',
    tagline: 'More accounts for a working outbound motion',
    monthlyPrice: 699,
    annualMonthlyPrice: 599,
    yearlyPrice: 7188,
    popular: true,
    features: [
      'LinkedIn and email',
      '10 LinkedIn accounts',
      '10 managed mailboxes (~500 emails/day)',
      '5,000 new contacts / month',
      'Research and copy included',
    ],
    mailSubject: 'Halr Growth plan',
  },
  {
    id: 'scale',
    name: 'Scale',
    tagline: 'The full self-serve sending footprint',
    monthlyPrice: 1199,
    annualMonthlyPrice: 999,
    yearlyPrice: 11988,
    features: [
      'LinkedIn and email',
      '25 LinkedIn accounts',
      '15 managed mailboxes (~750 emails/day)',
      '12,500 new contacts / month',
      'Research and copy included',
    ],
    mailSubject: 'Halr Scale plan',
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    tagline: 'Calling, custom volume, and a security review',
    monthlyPrice: null,
    yearlyPrice: null,
    priceLabel: 'Talk to sales',
    custom: true,
    features: [
      'AI calling',
      'Custom contacts, mailboxes, and LinkedIn accounts',
      'SSO and a security review',
      'Dedicated support',
    ],
    mailSubject: 'Halr Enterprise',
  },
];

/** One-time add-on. Priced above Scale's included per-contact rate. */
export const CONTACT_PACK = {
  contacts: 1000,
  price: 199,
  name: '1,000 extra contacts',
  detail: 'For the current month. $0.20 each, above the contacts included in a plan.',
};

export const TRIAL_INCLUDES = [
  '14 days',
  'LinkedIn only',
  '1 LinkedIn account',
  '200 new contacts',
  'No mailboxes and no calling',
];
